import type { ErrorEvent, EventHint } from '@sentry/react';

const TRANSLATION_SENSITIVE_ERROR = /removeChild|insertBefore/;

// Diagnostic probe for MONZA-2A6: React's removeChild/insertBefore throws are
// suspected to come from Chromium page-translation mutating the DOM. Chrome/Edge
// stamp <html class="translated-ltr|rtl"> and wrap text in <font> tags, so capturing
// that state at crash time confirms or refutes the translation hypothesis in prod.
export const attachTranslationFingerprint = (event: ErrorEvent, hint?: EventHint): ErrorEvent => {
  try {
    const error = hint?.originalException;
    const message = error instanceof Error ? error.message : String(error ?? '');

    if (!TRANSLATION_SENSITIVE_ERROR.test(message)) {
      return event;
    }

    const html = document.documentElement;
    const translated =
      html.classList.contains('translated-ltr') || html.classList.contains('translated-rtl');

    return {
      ...event,
      tags: { ...event.tags, pageTranslated: translated },
      contexts: {
        ...event.contexts,
        domTranslation: {
          htmlClass: html.className,
          htmlLang: html.lang,
          fontNodeCount: document.querySelectorAll<Element>('font').length,
        },
      },
    };
  } catch {
    return event;
  }
};
